import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MyDashboardComponent } from './pages/my-dashboard/my-dashboard.component';
import { MyDashboardRoutingModule } from './my-dashboard-routing.module';
import { SharedModule } from 'src/app/shared/shared.module';
import { MyDashbordListComponent } from './components/my-dashboard-list/my-dashboard-list.component';
import { AddNewMyDashboardComponent } from './components/add-new-my-dashboard/add-new-my-dashboard.component';
import { MyDashboardEditComponent } from './components/my-dashboard-edit/my-dashboard-edit.component';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatIconModule } from '@angular/material/icon';
import { NgSelectModule } from '@ng-select/ng-select';
import { MatMenuModule } from '@angular/material/menu';



@NgModule({
  declarations: [
    MyDashboardComponent,
    MyDashbordListComponent,
    AddNewMyDashboardComponent,
    
    MyDashboardEditComponent
  ],
  imports: [
    CommonModule,
    MyDashboardRoutingModule,
    FormsModule,
    ReactiveFormsModule,
    NgSelectModule,
    
    MatIconModule,
    MatMenuModule,
    SharedModule
  ]
})
export class MyDashboardModule { }
